<template>
  <div
    class="down-loading"
    :class="{
      'scroll-touch': !isShowMasking,
      'down-loading-ios': isIos11,
      'down-loading-hidden': isYumnow,
    }"
    @click="touchScheme"
    :style="mainStyle"
  >
    <div class="down-loading-main">
      <!-- <DebugLint v-if="debugInput" :debugInput="debugInput" /> -->
      <div class="page-banner" v-if="isSixNew">
        <img v-if="lang === 'zh'" class="page-banner-img" :src="require('$common/images/six-page-bg-zh.png')" />
        <img v-else-if="lang === 'km'" class="page-banner-img" :src="require('$common/images/six-page-bg-km.png')" />
        <img v-else class="page-banner-img" :src="require('$common/images/six-page-bg-en.png')" />
      </div>
      <div class="page-banner" v-else>
        <!-- <img class="page-banner-img" src="./images/page-bg.png" alt=""> -->
        <img v-if="lang === 'zh'" class="page-banner-img" :src="require('$common/images/page-bg-zh.png')" />
        <img v-else-if="lang === 'km'" class="page-banner-img" :src="require('$common/images/page-bg-km.png')" />
        <img v-else class="page-banner-img" :src="require('$common/images/page-bg-en.png')" />
      </div>

      <ul class="button-site">
        <li
          class="button-item"
          v-for="(e, i) in btns"
          :key="'btns-' + (i + 1)"
          v-show="e.show && !isYumnow"
        >
          <!-- <DownButton @click="e.click">
            <wownow-image
              :src="e.img.src"
              class="btn-logo btn-float-left"
              :style="e.img.style"
            />
            <div
              class="btn-content btn-float-left btn-zh-font-size"
              v-if="lang === 'zh'"
              v-text="e.zhName"
            />
            <p class="btn-float-left">
              <wownow-image
                class="btn-content btn-en-tips"
                :class="e.en.tipsClass"
                v-if="lang !== 'zh' && $root.clientWidth <= 400"
                :src="e.en.tips"
              />
              <span
                class="btn-en-tips-content"
                v-else-if="lang !== 'zh' && $root.clientWidth > 400"
                v-text="e.en.tipsContent"
              />
            </p>
            <p
              v-if="lang !== 'zh'"
              class="btn-con-text btn-float-left"
              v-text="e.en.content"
            />
          </DownButton> -->
          <DownButton @click="handleDownButton(e)">
            <div class="btn-logo-wrap">
              <wownow-image
                :src="e.img.src"
                class="btn-logo"
                :style="e.img.style"
              />
            </div>
            <div class="btn-content">
              <p
                class="btn-content-tips"
                v-if="lang === 'en'"
                v-text="e.en.tipsContent"
              />
              <p
                class="btn-content-tips"
                v-else-if="lang === 'km'"
                v-text="e.km.tipsContent"
              />
              <p
                class="btn-con-text"
                v-else
                v-text="e.zhName"
              />
              <p
                v-if="lang === 'en'"
                class="btn-con-text"
                v-text="e.en.content"
              />
               <p
                v-if="lang === 'km'"
                class="btn-con-text"
                v-text="e.km.content"
              />
            </div>
          </DownButton>
        </li>
      </ul>
    </div>
    <transition name="slide-fade">
      <OpenStep v-if="isShowMasking && !isTips" v-model="isShowMasking" />
      <div
        class="masking"
        :style="mainStyle"
        v-else-if="isShowMasking && isTips"
        @click="!(isShowMasking = false) && (isTips = false)"
      >
        <div class="masking-content scroll-touch">
          <div class="masking-tips-site copy-pop-tips">
            {{ copyI18n.copySuccess }}
          </div>
        </div>
      </div>
      <div
        class="masking"
        :style="mainStyle"
        v-else-if="isShowDownload"
      >
        <div class="masking-content scroll-touch">
          <wownow-image src="https://img.tinhnow.com/wownow/static/wownow-download/close.png" class="close-icon" @click="!(isShowDownload = false)" />
          <div class="masking-tips-site copy-pop-tips show-download">
            <wownow-image
              src="https://img.tinhnow.com/wownow/static/wownow-download/download-loading.png"
              alt=""
              class="download-loading-img"
            />
            <div class="download-loading-txt">{{ downloadTxt }}</div>
          </div>
        </div>
      </div>
    </transition>
    <Yumnow v-if="isYumnow" :copyI18n="copyI18n" />
    <WxOpenLaunchApp
      :extinfoProps="goAppRouter"
      v-if="wechatAppid && $root.isWechat"
      :appid="wechatAppid"
      @click="onWxOpenLaunchAppClick"
      :clientWidth="$root.clientWidth"
      :clientHeight="$root.clientHeight"
      @launch-error="launchError"
    />
  </div>
</template>

<script>
import LogoSite from "$downLoading/components/logo-site";
import BodyPhone from "$downLoading/components/body-phone";
import DownButton from "$downLoading/components/down-button";
import indexMixins from "./index-mixins";
import languageUtils from "$common/utils/language";
import Yumnow from "$downLoading/components/yumnow";
import WxOpenLaunchApp from '$common/components/wechat/wx-open-launch-app';
import WechatJssdk from '$common/utils/wechat/web-jssdk';
import { uploadEventList } from '$common/utils/event-tracking/page';
import OpenStep from '$common/components/open-step/open-step'
import DebugLint from './debug-lint';

console.log(OpenStep)
// import OuterCasing from '$common/components/component-outer-casing';
export default {
  mixins: [indexMixins],
  components: { LogoSite, BodyPhone, DownButton, Yumnow, WxOpenLaunchApp, OpenStep, DebugLint },
  documentTitle: "WOWNOW",
  created() {
    this.$root.maxWidth = 1024;
    // this.$root.maxFontSizeWidth = 375;
    WechatJssdk.config()?.then(res => WechatJssdk?.share())?.catch(err => {
      console.log('WechatJssdk err: ', err)
    });
    console.log("document.visibilityState")
    console.log(document.visibilityState)
    if (window.ssrConfig?.routerConfig?.isWechat) {
      return;
    }
    console.log('this.locationQuery',this.locationQuery)
    setTimeout(() => {
      if (this.isIOS && document.visibilityState === 'visible') {
        const appleLint = this.downLoad?.apple;
        window.location.href = appleLint || 'itms-appss://itunes.apple.com/app/id1507128993';
      } else if (this.isAndroid && document.visibilityState === 'visible' && this?.locationQuery?.routePath) {
        window.location.href = this.currentSchemeUrl
      }
    }, 500)
  },
  data() {
    return {
      isSixNew: false,
      wechatAppid: window?.ssrConfig?.routerConfig?.appid ?? '',
      isShowMasking: false,
      isShowDownload: false,
      schemeStatus: false,
      iosUrl:
        window?.ssrConfig?.routerConfig?.scheme?.ios ??
        "superapp://h5.lifekh.com/wakeup?routepath=",
      androidUrl:
        window?.ssrConfig?.routerConfig?.scheme?.android ?? "yumnow://",
      isTips: false,
      debugInput: ''
    };
  },
  computed: {
    uniLink() {
      const uniLink = this?.locationQuery?.uniLink ?? ''
      if (uniLink) {
        return decodeURIComponent(uniLink)
      }
      return ''
    },
    channel() {
      return this?.locationQuery?.channel ?? 'blank'
    },
    fromType() {
      return this?.locationQuery?.fromType ?? 'blank'
    },
    fromNo() {
      return this?.locationQuery?.fromNo ?? 'blank'
    },
    goAppRouter() {
      return decodeURIComponent(this?.locationQuery?.routePath ?? this?.locationQuery?.routepath ?? '');
    },
    mainStyle() {
      return (this.clientHeight && `height: ${this.clientHeight}px;`) || "";
    },
    locationQuery() {
      let queries = {};
      try {
        let search = window.location.search.match(/\?.*(?=\b|#)/);
        if (search) {
          search = search[0].replace(/^\?/, "");
        }
        if (search) {
          search.split('&').forEach((item) => {
            const param = item.split('=');
            if (param[1]) {
              // 单独针对安卓的routePath的编码 先解码再编码
              if(this.isAndroid && (param[0] == 'routePath' || param[0] == 'routepath')){
                console.log('匹配到routepath参数')
                let decode = decodeURIComponent(param[1])
                queries[param[0]] = encodeURIComponent(decode)
              }else {
                queries[param[0]] = decodeURIComponent(param[1])
              }
            }
          });
        }
        if (typeof window?.ssrConfig?.routerConfig?.short?.params === 'object' && !Array.isArray(window?.ssrConfig?.routerConfig?.short?.params)) {
          queries = Object.assign({}, queries, window.ssrConfig.routerConfig.short.params);
        }
        return queries;
      } catch (err) {
        console.log("整理参数失败: ", err);
        return {};
      }
    },
    downloadTxt() {
      return this.lang === "zh" ? "下载中，请稍后…" : this.lang === "en" ? 'Downloading, please wait…' : 'កំពុងទាញយក សូមរង់ចាំ…'
    },
    maskingLang() {
      return {
        one: {
          one: this.lang === "zh" ? "点击右上角的" : this.lang === 'en' ? "Click On The Upper-right" : 'ចុចលើប៊ូតុងស្តាំខាងលើ',
          two: this.lang === "zh" ? "按钮" : this.lang === 'en' ? "Button" : "ប៊ូតុង"
        },
        two: {
          one: this.lang === "zh" ? "选择" : this.lang === 'en' ? "Select" : 'ជ្រើសរើស',
          two: this.lang === "zh" ? "在浏览器中打开" : this.lang === 'en' ? "Open In Browser" : 'បើកនៅក្នុងBrowser'
        }
      };
    },
    copyI18n() {
      return {
        downloadUrl:
          (this.lang === "zh" && this.copyUrlI18n.downloadUrl.zh) ||
          this.copyUrlI18n.downloadUrl.en,
        copyLabel:
          (this.lang === "zh" && this.copyUrlI18n.copyLabel.zh) ||
          this.copyUrlI18n.copyLabel.en,
        copyUrlTips:
          (this.lang === "zh" && this.copyUrlI18n.copyUrlTips.zh) ||
          this.copyUrlI18n.copyUrlTips.en,
        copySuccess:
          (this.lang === "zh" && this.copyUrlI18n.copySuccess.zh) ||
          this.copyUrlI18n.copySuccess.en
      };
    },
    copyUrlI18n() {
      return {
        downloadUrl: {
          en: "WOWNOW",
          zh: "WOWNOW"
        },
        copyLabel: {
          en: "Copy",
          zh: "复制"
        },
        copyUrlTips: {
          en: "Copy the link, and open in system browser",
          zh: "点击按钮，前往下载"
        },
        copySuccess: {
          en: "Copy successfully, please open in system browser",
          zh: "复制成功，去浏览器黏贴打开"
        }
      };
    },
    isIos11() {
      return (
        this.getIosVersion &&
        this.getIosVersion.length &&
        this.getIosVersion[0] < 12
      );
    },
    getIosVersion() {
      if (this.isIOS) {
        return navigator.userAgent.toLocaleLowerCase()
          .match(/os [\d._]*/gi)
          .toString()
          .replace(/[^0-9|_.]/gi, "")
          .replace(/_/gi, ".")
          .split(".")
          .map((e) => e - 0);
      }
      return 0;
    },
    isDingTalk: () => navigator.userAgent.toLowerCase().indexOf('dingtalk') !== -1,
    isIOS: () => navigator.userAgent.toLocaleLowerCase().indexOf('mac os x') !== -1,
    isQQ: () => navigator.userAgent.toLowerCase().indexOf('qq/') !== -1,
    isAndroid: () => navigator.userAgent.toLocaleLowerCase().indexOf('android') !== -1,
    isWechat: () => navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1,
    lang() {
      const navigatorLanguage = languageUtils.getPageHeaderCurrentLanguage;
      return navigatorLanguage.indexOf("zh") !== -1
        ? "zh"
        : navigatorLanguage.indexOf("en") !== -1
          ? "en"
          : "km";
    },
    currentSchemeUrl() {
      const routePath = this.locationQuery.routePath || this.locationQuery.routepath || ''
      if (this?.locationQuery?.isH5) {
        return `${this.isIOS && this.iosUrl || 'superapp://tinhnow/route?url='}${routePath}`;
      }
      if (this.isIOS) {
        return `${this.iosUrl}${routePath}`;
      }
      if (this.androidUrl === 'superapp://wownow/route?url=') {
        return `${this.androidUrl}${routePath}`;
      } else {
        return `${this.androidUrl}${routePath.replace?.(/SuperApp%3A%2F%2F|SuperApp:\/\//i, '') ?? 'YumNow/storeDetail'}`;
      }
      // const routePathAndroid = routePath.replace?.(/SuperApp%3A%2F%2F|SuperApp:\/\//|, '')
    },
    isYumnow: () => window?.ssrConfig?.routerConfig?.isYumnow ?? false
  },
  mounted() {
    this.isSixNew = window.location.href.indexOf('isSixNew') !== -1
    if (this.isSixNew) {
      uploadEventList([{
        businessName: '领券活动页面的下载页PV',
        eventGroup: 'other',
        event: 'sms_marketing_downloadPagePV',
        ext: {
          phone: this?.locationQuery?.phone,
          activityNo: this?.locationQuery?.activityNo
        }
      }]);
    } else {
      uploadEventList([{
        businessName: 'H5下载页PV',
        eventGroup: 'other',
        event: 'download_page_pv',
        ext: {
          channel: this.channel,
          fromType: this.fromType,
          fromNo: this.fromNo
        }
      }]);
    }
  },
  methods: {
    handleDownButton(e) {
      if (e.name !== 'android') {
        // 只统计安卓最后一次点击的上报
        uploadEventList([
          {
            businessName: "下载页面点击下载按钮",
            eventGroup: "other",
            event: "download_page_click_download",
            ext: {
              channel: this.channel,
              downloadType: e.name,
              fromType: this.fromType,
              fromNo: this.fromNo
            }
          }
        ]);
      }
      e && e.click()
    },
    onWxOpenLaunchAppClick() {
      this.wechatAppid = ''
      // 不管微信有没有唤起，都点一下按钮
      setTimeout(() => {
        this.launchError()
      }, 300)
    },
    launchError(res) {
      console.log('launch error')
      console.log(res)
      if (this.isIOS) {
        this.appleClick();
        return;
      }
      this.androidClick();
    },
    touchScheme() {
      console.log('touch scheme')
      console.log(this.isWechat)
      console.log(this.isAndroid)
      console.log(this.schemeStatus)
      if (
        !this.isWechat &&
        this.isAndroid &&
        !this.schemeStatus
      ) {
        this.schemeStatus = true;
        this.schemeUrl();
      }
    },
    schemeUrl() {
      console.log("this.currentSchemeUrl")
      console.log(this.currentSchemeUrl)
      this.debugInput = this.currentSchemeUrl
      window.location.href = this.currentSchemeUrl;
    },
    checkMasking(callback) {
      this.isShowMasking = !!(this.isWechat || this.isDingTalk || this.isQQ);
      console.log(this.isShowMasking)
      typeof callback === "function" && callback(!this.isShowMasking);
    }
  }
};
</script>
<style lang="stylus">
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video,
  input {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font-weight: normal;
    vertical-align: baseline;
    box-sizing: border-box;
    outline: none;
  }

  body {
    line-height: 1;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  a {
    color: #7e8c8d;
    -webkit-backface-visibility: hidden;
    text-decoration: none;
  }

  li {
    list-style: none;
  }

  body,
  html {
    position: relative;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    line-height: 1;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    text-size-adjust: none;
    text-rendering: optimizeLegibility;
    -webkit-text-size-adjust: none;
    -webkit-touch-callout: none;
    -webkit-font-smoothing: antialiased;
    -webkit-backface-visibility: hidden;
    -webkit-user-drag: none;
    background: -webkit-linear-gradient(0deg, #F83E00 0%, #FF6E00 100%);
    background: -moz-linear-gradient(0deg, #F83E00 0%, #FF6E00 100%);
    background: -o-linear-gradient(0deg, #F83E00 0%, #FF6E00 100%);
    background: -ms-linear-gradient(0deg, #F83E00 0%, #FF6E00 100%);
    background: linear-gradient(90deg, #F83E00 0%, #FF6E00 100%);
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    overflow: hidden;
  }

  .scroll-touch {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .display-middle {
    display: inline-block;
    vertical-align: middle;
  }
  /*滚动条样式*/
  *::-webkit-scrollbar {/*滚动条整体样式*/
    width: 0px;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 0px;
    display: none;
  }
  *::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 0px;
    -webkit-box-shadow: inset 0 0 0px rgba(0,0,0,0);
    background: rgba(0,0,0,0);
    display: none;
  }
  *::-webkit-scrollbar-track {/*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 0px rgba(0,0,0,0);
    border-radius: 0;
    background: rgba(0,0,0,0);
    display: none;
  }
</style>
<style lang="stylus" scoped>
.down-loading {
  /* background-color: #F01731; */
  background: linear-gradient(to right, #feeee7 0%, #fff7f4 50%, #feefe8 100%);
}

.page-banner {
  .page-banner-img {
    display: block;
    width: 100%;
  }
}

.btn-logo {
  width: 27px;
}

.btn-content {
  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
}

>>> .down-button {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: opacity .5s;
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: opacity .5s;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
.header-icon {
  max-height: 253.94Px;
  width: 100%;
}
.position-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.position-top {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0%);
}
.position-left {
  position: absolute;
  top: 50%;
  transform: translate(0%, -50%);
}
.down-loading {
  width: 100vw;
  // height: 100vh;
  height: 100%;
}
.down-loading-hidden {
  overflow: hidden;
}
.down-loading-ios {
  // padding-bottom: 30px;
}

.down-loading-main {
}

.button-site {
  // position: absolute;
  // bottom: 0;
  // left: 0;
  width: 100%;
  padding-bottom: 20px;

  >>> .down-button {
    background-color: #FC2040;
    .btn-con-text {
      color: #fff;
      font-size: 16px;
      font-family: SanFranciscoText-Heavy, SanFranciscoText;
      font-weight: 800;
    }
  }

  >>> .wownow-image {
    width: 20px;
  }
}

.button-item {
  margin-top: 14px;
}

.btn-logo {
  margin-right: 14px;
}

.btn-float-left {
  // float: left;
}

.btn-zh-font-size {
  font-size: 16px;
  padding-top: 8px;
}

.btn-en-tips {
  margin-top: 2px;
}
.btn-en-tips-content {
  font-size: 10px;
  font-weight: bold;
}

.btn-en-content {
  margin-top: 2px;
}

.btn-logo-wrap {
  text-align: right;
}

.btn-content {
  min-width: 40%;
  text-align: left;
  display: inline-flex;
  flex-direction: column;
  .btn-content-tips {
    font-size: 12px;
  }
}

.btn-con-text {
  font-size: 16px;
  font-weight: bold;
}

.get-it-on {
  width: 49px;
}

.download-on-the {
  width: 91px;
}

.i-have-no-google {
  width: 82px;
}

.masking {
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  background-color: rgba(46, 45, 45, 0.8);
}

.masking-content {
  width: 100%;
  height: 100%;
  position: relative;
}
.masking-tips-site {
  min-width: 100%;
  text-align: center;
  width: fit-content;
  height: 78px;
  color: #fff;
  font-weight: bold;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index 999;
  padding: 0 20px;
}
.tips-row {
  margin-bottom: 18px;
}
.round {
  width: 18px;
  height: 18px;
  line-height 18px;
  border-radius: 50%;
  background-color #ff6d00
  font-size: 15.5px;
  text-align center
  margin-right 10px;
}
.tips-text {
  font-size: 20.5px;
}
.blue-menu {
  margin: 0 5px;
  width: 26px;
}
.blue-button {
  margin: 0 5px;
  width: 160px;
}
.blue-button-site {
  position relative
}
.earth {
  width: 22px;
  position: absolute;
  top: 50%;
  transform: translate(0%, -50%);
  left: 10px;
}
.earth-text {
  position: absolute;
  top: 50%;
  transform: translate(0%, -50%);
  left: 38px;
  font-size: 14px;
}
.copy-button {
  position relative;
  width: fit-content;
  margin: 0 auto;
}
.copy-logo {
  width: 176px;
  margin: 0 auto;
  display block;
}
.copy-btn-content {
  font-size: 15px;
  font-family: Segoe UI;
  font-weight: 600;
  color: #fff;
  left: 15px;
  line-height: 0;
}
.copy-btn-content-right {
  font-size: 15px;
  font-family: PingFang SC;
  line-height: 0;
  color: #683101;
  text-shadow: 0px 0px 10px rgba(238, 135, 0, 0.67);
  right: 14px;
}
.copy-tips-content {
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  width: fit-content;
  top: 46px;
  word-break: break-all;
}
.copy-pop-tips {
  font-size: 18px;
}

.download-loading-img {
  width: 37.5px;
  height: 37.5px;
  -webkit-transition-property: -webkit-transform;
  -webkit-transition-duration: 1s;
  -moz-transition-property: -moz-transform;
  -moz-transition-duration: 1s;
  -webkit-animation: rotate 2s linear infinite;
  -moz-animation: rotate 2s linear infinite;
  -o-animation: rotate 2s linear infinite;
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  from {
    -webkit-transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes rotate {
  from {
    -moz-transform: rotate(0deg);
  }

  to {
    -moz-transform: rotate(359deg);
  }
}

@keyframes rotate {
  from {
    -o-transform: rotate(0deg);
  }

  to {
    -o-transform: rotate(359deg);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(359deg);
  }
}
.close-icon {
  width: 30px;
  height: 30px;
  float: right;
  margin: 32px 30px 0 0;
}
.show-download {
  text-align center
}
.download-loading-txt {
  width: 100%;
  height: 28px;
  font-size: 20px;
  padding-top: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 28px;
  color: #FFFFFF;
  opacity: 1;
}
</style>
